'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Provides an adapter for presentation remotes.
//
// Technically, remotes are very small keyboards with a  limited
// number of keys. The forward and backward buttons simply send the same
// key codes as the cursor keys on a regular keyboard.

// The button to blank the screen simply sends the letter 'B' (and if
// you didn't know this, try hitting the 'B' key on your keyboard in your
// presentation software).
// (https://www.themobilepresenter.com/article.php/how-does-a-remote-work)

var k = {
  KEY_LEFT: 37,
  KEY_RIGHT: 39,
  KEY_DOWN: 40,
  KEY_UP: 38,
  KEY_SPACE: 32,

  // some clickers supports it
  // for example, Logitech
  KEY_PAGE_UP: 33,
  KEY_PAGE_DOWN: 34,

  // Blank screen
  KEY_B: 66
};

var RemoteControl = function (_React$Component) {
  _inherits(RemoteControl, _React$Component);

  function RemoteControl() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RemoteControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemoteControl.__proto__ || Object.getPrototypeOf(RemoteControl)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (e) {
      // Go to the next slide: right,
      // down arrow or space
      if (e.keyCode === k.KEY_RIGHT || e.keyCode === k.KEY_DOWN || e.keyCode === k.KEY_SPACE || e.keyCode === k.KEY_PAGE_DOWN) {
        return _this.props.onNext();
      }

      // Go to previous slide
      if (e.keyCode === k.KEY_LEFT || e.keyCode === k.KEY_UP || e.keyCode === k.KEY_PAGE_UP) {
        return _this.props.onPrev();
      }

      if (e.keyCode === k.KEY_B) {
        return _this.props.onMute();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RemoteControl, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return RemoteControl;
}(_react2.default.Component);

RemoteControl.propTypes = {
  onNext: _propTypes2.default.func.isRequired,
  onPrev: _propTypes2.default.func.isRequired,
  onMute: _propTypes2.default.func.isRequired
};
exports.default = RemoteControl;